import React from 'react'

interface StartRecordingIconProps {
  size?: 'sm' | 'lg'
}

export function StartRecordingIcon({ size }: StartRecordingIconProps) {
  return size === 'sm' ? (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" className="fill-danger-icon" />
    </svg>
  ) : (
    <div className="w-10 h-10 relative">
      <div className="w-9 h-9 left-0.5 top-0.5 absolute bg-danger-icon rounded-full" />
    </div>
  )
}
